// src/modules/serviceRecords/components/ServiceItemsTable.js
// Servis kaydı malzeme/hizmet tablosu bileşeni

import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, TextField, IconButton, Typography, Chip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import InventoryIcon from '@mui/icons-material/Inventory';
import BuildIcon from '@mui/icons-material/Build';
import EditIcon from '@mui/icons-material/Edit';
import { formatCurrency } from '../../../utils/formatters';

const ServiceItemsTable = ({
    items,
    onRemove,
    onMiktarChange,
    onFiyatChange
}) => {
    if (items.length === 0) return null;

    return (
        <TableContainer component={Paper} variant="outlined" sx={{ mb: 2 }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell width="50">Tip</TableCell>
                        <TableCell>Ad</TableCell>
                        <TableCell width="120" align="center">Miktar</TableCell>
                        <TableCell width="150" align="right">Birim Fiyat</TableCell>
                        <TableCell width="150" align="right">Toplam</TableCell>
                        <TableCell width="80" align="center">İşlem</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                {item.tip === 'urun' ? (
                                    <Chip icon={<InventoryIcon />} label="Ürün" size="small" color="primary" />
                                ) : item.tip === 'hizmet' ? (
                                    <Chip icon={<BuildIcon />} label="Hizmet" size="small" color="secondary" />
                                ) : (
                                    <Chip icon={<EditIcon />} label="Manuel" size="small" />
                                )}
                            </TableCell>
                            <TableCell>{item.ad}</TableCell>
                            <TableCell align="center">
                                <TextField
                                    type="number"
                                    value={item.miktar}
                                    onChange={(e) => onMiktarChange(index, e.target.value)}
                                    size="small"
                                    inputProps={{ min: 1, style: { textAlign: 'center' } }}
                                    sx={{ width: 80 }}
                                />
                            </TableCell>
                            <TableCell align="right">
                                <TextField
                                    type="number"
                                    value={item.birimFiyat}
                                    onChange={(e) => onFiyatChange(index, e.target.value)}
                                    size="small"
                                    inputProps={{ min: 0, step: 0.01 }}
                                    sx={{ width: 120 }}
                                />
                            </TableCell>
                            <TableCell align="right">
                                <Typography fontWeight="bold">
                                    {formatCurrency(item.toplamFiyat)}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <IconButton color="error" size="small" onClick={() => onRemove(index)}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ServiceItemsTable;
